// Contact-sharing guard for the PawCita chat. Enforced on the frontend for
// instant feedback and again on the backend for real protection.
const blockedPatterns = [
  /\b\d{3,4}[\s\-.]?\d{3,4}[\s\-.]?\d{0,4}\b/, // phone numbers
  /(?:\+?\d{1,3}[\s\-.]?)?\(?\d{2,4}\)?[\s\-.]?\d{2,4}[\s\-.]?\d{2,4}/, // international phones
  /[A-Z0-9._%+\-]+@[A-Z0-9.\-]+\.[A-Z]{2,}/i, // emails
  /(https?:\/\/|www\.)/i, // urls
  /\.(com|net|org|ai|co|io|me|app|xyz|gg|tv|es|ee)\b/i, // domains
  /(^|[^\w@])@[a-z0-9._]{2,}/i, // social handles like @bruce_the_dog
  /\b(instagram|insta|ig|facebook|fb|tiktok|whatsapp|wa\.me|telegram|snapchat|twitter|linktr|linktree|onlyfans|discord|gmail|hotmail|outlook|yahoo)\b/i,
];

export function containsExternalContact(text) {
  if (!text) return false;
  return blockedPatterns.some((regex) => regex.test(text));
}
